<template>
  <div class="mode-free-skills">
    <PrimarySkills :initPrimarySkills="initPrimarySkills" ref="primarySkills"></PrimarySkills>
    <SecondarySkills :initSecondarySkills="initSecondarySkills" ref="secondarySkills"></SecondarySkills>
  </div>
</template>

<script>
  import PrimarySkills from './primary-skills'
  import SecondarySkills from './secondary-skills'

  export default {
    name: 'skills',

    props: {
      initPrimarySkills: {
        type: Object,
        default () {
          return null
        }
      },
      initSecondarySkills: {
        type: Array,
        default () {
          return null
        }
      },
    },

    methods: {
      getPrimarySkills () {
        return this.$refs.primarySkills.getFormData()
      },

      getSecondarySkills () {
        return this.$refs.secondarySkills.getFormData()
      },
    },

    components: {
      PrimarySkills,
      SecondarySkills,
    }
  }
</script>

<style lang="stylus" scoped>
  .secondary-skills
    margin-top 20px
</style>
